import React from 'react';
import { Button } from '../../ui/Button';

interface ApplicationSettingsProps {
  generalSettings: {
    applicationName: string;
    companyName: string;
    supportEmail: string;
    defaultTimezone: string;
    notesEnabled: boolean;
    bulletinsEnabled: boolean;
  };
  isGeneralSettingsSaving: boolean;
  onSettingsChange: (field: string, value: any) => void;
  onSave: () => void;
  onReset: () => void;
}

export const ApplicationSettings: React.FC<ApplicationSettingsProps> = ({
  generalSettings,
  isGeneralSettingsSaving,
  onSettingsChange,
  onSave,
  onReset
}) => {
  return (
    <div>
      <div className="mb-6">
        <h4 className="text-lg font-medium" style={{ color: 'var(--color-text-primary)' }}>
          Application Settings
        </h4>
        <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
          Configure general application preferences and behavior
        </p>
      </div>
      
      <div className="max-w-2xl space-y-6">
        <div>
          <label className="block text-sm font-medium mb-2" style={{ color: 'var(--color-text-primary)' }}>
            Application Name
          </label>
          <input
            type="text"
            value={generalSettings.applicationName}
            onChange={(e) => onSettingsChange('applicationName', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2"
            style={{
              backgroundColor: 'var(--color-bg-primary)',
              borderColor: 'var(--color-border)',
              color: 'var(--color-text-primary)',
              '--tw-ring-color': 'var(--color-accent)',
              '--tw-ring-offset-color': 'var(--color-bg-primary)'
            } as React.CSSProperties}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-2" style={{ color: 'var(--color-text-primary)' }}>
            Company Name
          </label>
          <input
            type="text"
            value={generalSettings.companyName}
            onChange={(e) => onSettingsChange('companyName', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2"
            style={{
              backgroundColor: 'var(--color-bg-primary)',
              borderColor: 'var(--color-border)',
              color: 'var(--color-text-primary)',
              '--tw-ring-color': 'var(--color-accent)',
              '--tw-ring-offset-color': 'var(--color-bg-primary)'
            } as React.CSSProperties}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-2" style={{ color: 'var(--color-text-primary)' }}>
            Support Email
          </label>
          <input
            type="email"
            value={generalSettings.supportEmail}
            onChange={(e) => onSettingsChange('supportEmail', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2"
            style={{
              backgroundColor: 'var(--color-bg-primary)',
              borderColor: 'var(--color-border)',
              color: 'var(--color-text-primary)',
              '--tw-ring-color': 'var(--color-accent)',
              '--tw-ring-offset-color': 'var(--color-bg-primary)'
            } as React.CSSProperties}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-2" style={{ color: 'var(--color-text-primary)' }}>Default Timezone</label>
          <select 
            value={generalSettings.defaultTimezone}
            onChange={(e) => onSettingsChange('defaultTimezone', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2"
            style={{
              backgroundColor: 'var(--color-bg-primary)',
              borderColor: 'var(--color-border)',
              color: 'var(--color-text-primary)',
              '--tw-ring-color': 'var(--color-accent)',
              '--tw-ring-offset-color': 'var(--color-bg-primary)'
            } as React.CSSProperties}
          >
            <option value="America/New_York">Eastern Time (ET)</option>
            <option value="America/Chicago">Central Time (CT)</option>
            <option value="America/Denver">Mountain Time (MT)</option>
            <option value="America/Los_Angeles">Pacific Time (PT)</option>
            <option value="UTC">UTC</option>
          </select>
        </div>
      </div>
      
      <div className="flex justify-end space-x-3 mt-8">
        <Button
          variant="secondary"
          onClick={onReset}
          size="sm"
        >
          Reset to Defaults
        </Button>
        <Button
          variant="primary"
          onClick={onSave}
          disabled={isGeneralSettingsSaving}
          size="sm"
        >
          {isGeneralSettingsSaving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </div>
  );
};
